<template lang="pug">
  v-container#edit(fluid)
    h1.form-title.dark-text ¿Por qué editaste el caso?
    v-form
      v-layout(row wrap)
        v-radio-group(
          v-model="editReason"
        )
          v-flex(d-flex)
            v-radio(
              label="Actualización del caso"
              value="update"
            )
            v-radio(
              label="Corrección de errores"
              value="fix"
            )
      v-layout(row wrap)
        v-text-field(
          label="Comentarios de la versión"
          v-model="editComments"
        )
</template>
<script>
export default {
  name: "Edit",
  props: {},
  data() {
    return {};
  },
  computed: {
    editReason: {
      get() {
        return this.$store.state.record["edit_reason"];
      },
      set(value) {
        this.$store.commit("updateEditReason", value);
      }
    },
    editComments: {
      get() {
        return this.$store.state.record["edit_comments"];
      },
      set(value) {
        this.$store.commit("updateEditComments", value);
      }
    }
  },
  beforeMount() {
    this.$store.state.record["edit_reason"] = "update";
  }
};
</script>
<style scoped lang="scss">
</style>
